import { useEffect } from 'react';

const DEFAULT_SITE_NAME = 'Sprout Academy';
const DEFAULT_IMAGE = '/logo192.png';

const setMetaTag = (key, value, attribute = 'name') => {
  const selector = `meta[${attribute}="${key}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', value);
};

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]');

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }

  link.setAttribute('href', href);
};

const setJsonLd = (schemaObject) => {
  const id = 'seo-json-ld';
  let script = document.getElementById(id);

  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(schemaObject);
};

const SEO = ({
  title,
  description,
  path = '/',
  siteName = DEFAULT_SITE_NAME,
  image = DEFAULT_IMAGE,
  type = 'website',
}) => {
  useEffect(() => {
    const origin = window.location.origin;
    const pageUrl = `${origin}${path}`;
    const imageUrl = image.startsWith('http') ? image : `${origin}${image}`;

    document.title = title;
    setMetaTag('description', description);
    setCanonical(pageUrl);

    setMetaTag('og:title', title, 'property');
    setMetaTag('og:description', description, 'property');
    setMetaTag('og:type', type, 'property');
    setMetaTag('og:url', pageUrl, 'property');
    setMetaTag('og:site_name', siteName, 'property');
    setMetaTag('og:image', imageUrl, 'property');

    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', imageUrl);

    setJsonLd({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: title,
      description,
      url: pageUrl,
      isPartOf: {
        '@type': 'WebSite',
        name: siteName,
        url: origin,
      },
    });
  }, [description, image, path, siteName, title, type]);

  return null;
};

export default SEO;